import service from "auth/FetchInterceptor";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { updateDataState } from "redux/actions";
import { GET_AREA, GET_CATEGORIES, GET_CATEGORY_PRODUCTS, GET_CITY, GET_COUNTRIES, GET_PICKUP, GET_PRODUCT, SEARCH, SELECTED_BRANCH, STORE_DATA, STORE_LOGO, STORE_TIMING, GET_SOCIAL_ICON, MAKE_ORDER, GET_ORDER_CHECK_STATUS, CHECK_ORDER, GET_PROMOTION_BANNERS, GET_PROMOTION, GET_PINNED_BOX } from "redux/constants/fetchedData";

const storeId = process.env.REACT_APP_STORE_ID

function* getLogo() {
    yield templateSaga(STORE_LOGO, 'v1/store/logo/'+storeId, 'logo')
}
function* getStoreData() {
    yield templateSaga(STORE_DATA, 'v1/store/data/'+storeId, 'storeData')
}
function* getTimings() {
    yield templateSaga(STORE_TIMING, 'v1/store/timing/'+storeId, 'timings')
}
function* getCategories() {
    yield put(updateDataState({categoryLoading:true}))
    yield templateSaga(GET_CATEGORIES, 'v1/category/'+storeId, 'categories', 'path')
}
function* getCategoryProducts() {
    yield templateSaga(GET_CATEGORY_PRODUCTS, 'v1/product/by_category_id/', 'categoryProducts', 'path')
}
function* getProduct() {
    yield templateSaga(GET_PRODUCT, 'v1/product/', 'product', 'path')
}
function* getCountries() {
    yield templateSaga(GET_COUNTRIES, '/v1/country/get_all/'+storeId, 'countries', 'path')
}
function* getCities() {
    yield templateSaga(GET_CITY, '/v1/country/city/get/', 'cities', 'path')
}
function* getAreas() {
    yield templateSaga(GET_AREA, '/v1/country/city/area/get_all', 'areas')
}
function* getPickups() {
    yield templateSaga(GET_PICKUP, '/v1/store/branch-timing/'+storeId, 'pickups')
}
function* getBranch() {
    yield templateSaga(SELECTED_BRANCH, '/v1/store/branch/', 'selectedBranch', 'path')
}
function* getSearch() {
    yield templateSaga(SEARCH, '/v1/product/search?storeId='+storeId, 'searchResults', 'path')
}
function* getSocialIcon() {
    yield templateSaga(GET_SOCIAL_ICON, '/v1/store/getNetworkList/' + storeId, 'socialIcon');
}
function* getOrderCheckStatus() {
    yield templateSaga(GET_ORDER_CHECK_STATUS, '/v1/order/check-status', 'orderCheckStatus', 'path');
}
function* getcheckedOrder() {
    yield templateSaga(CHECK_ORDER, '/v1/order/checkOrder/', 'checkedOrderData', 'path');
}
function* getPromotionBanners() {
    yield templateSaga(GET_PROMOTION_BANNERS, '/v1/store/bg/' + storeId, 'promotionBanners', 'path')
}
function* getPromotion() {
    yield templateSaga(GET_PROMOTION, `/v1/promotion/today?storeId=${storeId}&today=`, 'promotions', 'path')
}
function* getPinnedBox() {
    yield templateSaga(GET_PINNED_BOX, '/v1/pinned_box/' + storeId, 'pinnedBox', 'path');
}

function* templateSaga(type, url, varOfState, payloadType = '') {
    yield takeEvery(type, function* ({payload}) {
        yield put(updateDataState({orderCheckStatusLoading:true}))
        try {
            const {data} = yield call(service, {
                method: 'get',
                url: url+(payloadType==='path' ? payload : payloadType==='query' ? '&search='+payload : ''),
            });
            yield put(updateDataState({[varOfState]:data}));
            yield put(updateDataState({categoryLoading:false}))
            yield put(updateDataState({orderCheckStatusLoading:false}))
        } catch (err) {
            console.log(err);
        }
    });
}

function* makeOrderSaga(){
    yield takeEvery(MAKE_ORDER, function* ({payload}) {
        console.log(payload);
        try {
            const {data} = yield call(service, {
                method: 'post',
                url: '/v1/order/make-order/'+storeId,
                data: payload,
            });
            yield put(updateDataState({makeOrderResult:data}));
        } catch (err) {
            console.log(err);
        }
    });
}

export default function* rootSaga(){
    yield all([
        fork(getLogo),
        fork(getStoreData),
        fork(getTimings),
        fork(getCategories),
        fork(getCategoryProducts),
        fork(getProduct),
        fork(getCountries),
        fork(getCities),
        fork(getAreas),
        fork(getPickups),
        fork(getBranch),
        fork(getSearch),
        fork(getSocialIcon),
        fork(getOrderCheckStatus),
        fork(makeOrderSaga),
        fork(getcheckedOrder),
        fork(getPromotionBanners),
        fork(getPromotion),
        fork(getPinnedBox),
    ])
}